import { Link } from "@tanstack/react-router";

import logoFullLight from "../assets/brand/logo-full-light.png";
import logoMarkLight from "../assets/brand/logo-mark-light.png";

/** Размеры файла нужны, чтобы браузер зарезервировал место до загрузки картинки. */
const LOGO_FULL_SIZE = { width: 1000, height: 333 };
const LOGO_MARK_SIZE = { width: 445, height: 512 };

/**
 * Логотип в верхней части бокового меню. Меню тёмное, поэтому берётся светлый
 * вариант — тот же, что на публичном сайте на тёмных фонах.
 */
export function ErpLogo({
  label,
  onNavigate,
}: {
  label: string;
  onNavigate?: () => void;
}) {
  return (
    <Link className="erp-logo" to="/" aria-label={label} onClick={onNavigate}>
      <span className="erp-logo__lockup">
        <img
          className="erp-logo__image"
          src={logoFullLight}
          alt=""
          {...LOGO_FULL_SIZE}
        />
        <span className="erp-logo__tag" aria-hidden="true">
          ERP
        </span>
      </span>
    </Link>
  );
}

/** Знак на тёмном фоне страницы входа: светлый вариант тех же линий. */
export function LoginLogoMark() {
  return (
    <img
      className="login-brand__logo"
      src={logoMarkLight}
      alt=""
      {...LOGO_MARK_SIZE}
    />
  );
}
